let map;
let mapInitialized = false;

function initMap() {
    const markers = mapData?.markers || [];
    if (!markers.length) return;

    map = new google.maps.Map(document.getElementById('venue-map'), {
        zoom: 6,
        center: {
            lat: parseFloat(markers[0].lat),
            lng: parseFloat(markers[0].lng),
        },
        mapTypeControl: false,
    });

    const bounds = new google.maps.LatLngBounds();

    markers.forEach(marker => {
        const position = { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) };
        const mapMarker = new google.maps.Marker({
            position,
            map,
            title: marker.title,
        });

        const infowindow = new google.maps.InfoWindow({
            content: `
                <div style="min-width:220px;">
                    <h4 style="margin-bottom:4px;">${marker.title}</h4>
                    <p style="margin:0 0 5px;">${marker.address}</p>
                    <a href="${marker.permalink}" target="_blank" style="color:#0073aa;text-decoration:underline;">View Venue</a>
                </div>
            `,
        });

        mapMarker.addListener("click", () => {
            infowindow.open(map, mapMarker);
        });

        bounds.extend(position);
    });

    map.fitBounds(bounds);
    mapInitialized = true;
}

// Wait for DOM and Google Maps API to be ready
document.addEventListener('DOMContentLoaded', () => {
    const checkGoogleReady = setInterval(() => {
        if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
            clearInterval(checkGoogleReady);
            setupMapToggles();
        }
    }, 100);
});

function setupMapToggles() {
    const showBtn = document.getElementById('showMapView');
    const hideBtn = document.getElementById('hideMapView');
    const mapContainer = document.getElementById('venue-map');

    if (!showBtn || !hideBtn || !mapContainer) return;

    showBtn.addEventListener('click', () => {
        mapContainer.style.display = 'block';
        showBtn.classList.add('active');
        hideBtn.classList.remove('active');

        // Initialize map only once
        if (!mapInitialized) {
            initMap();
        } else {
            // Trigger map resize if it was hidden before
            google.maps.event.trigger(map, 'resize');
        }
    });

    hideBtn.addEventListener('click', () => {
        mapContainer.style.display = 'none';
        showBtn.classList.remove('active');
        hideBtn.classList.add('active');

        // Optional: completely remove the map from DOM if desired
        mapContainer.innerHTML = '';
        mapInitialized = false;
    });
}